const MercadoLibre = {
  enable() {},
  wait() {
    return true;
  },
  init() {},
  landing() {},
  paso1() {
    let ark = document.createElement("img");
    ark.src =
      "https://pubads.g.doubleclick.net/activity;xsp=4350684;ord=" +
      (Math.random() + "") * 10000000000000 +
      "?";
    ark.width = "1";
    ark.height = "1";
  },
  paso2() {},
  paso3() {},
  paso4() {},
  gracias(context) {
    let { isExceeded } = context.state;
    if (!isExceeded) {
      let ark = document.createElement("img");
      ark.src =
        "https://pubads.g.doubleclick.net/activity;xsp=4350684;ord=" +
        (Math.random() + "") * 10000000000000 +
        "?";
      ark.width = "1";
      ark.height = "1";
    }
  },
  mensaje() {}
};

export default MercadoLibre;
